/**
 * Converts string to camel case
 * @param  {string} s - string to convert to camelcase.
 * @returns {string}
 */
export const toCamel = s => s.replace(/_\w/g, m => m[1].toUpperCase());

/**
 * Checks if param is object or array.
 * @param {*} o - Wildcard input, can be any type.
 * @returns {boolean}
 */
const isObject = o => o === Object(o) && !Array.isArray(o);

/**
 * Converts object keys to camel case
 * @param {Object} o - Object or array input
 * @returns {*}
 */
export const keysToCamel = function (o) {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach(k => {
      n[toCamel(k)] = keysToCamel(o[k]);
    });
    return n;
  }

  if (Array.isArray(o)) {
    return o.map(i => keysToCamel(i));
  }

  return o;
};

/**
 * Converts object keys to snake case
 * @param {Object} o - Object or array input
 * @returns {Object}
 */
export const keysToSnake = function (o) {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach(k => {
      n[camelToSnake(k)] = keysToSnake(o[k]);
    });
    return n;
  }

  if (Array.isArray(o)) {
    return o.map(i => keysToSnake(i));
  }

  return o;
};

/**
 *  Converts camel to snake case
 * @param {string} str - input string
 * @returns {string}
 */
export const camelToSnake = str =>
  str.replace(/\.?([A-Z0-9])/g, (x, y) => `_${y.toLowerCase()}`).replace(/^_/, '');
